<div class="cf-flex-column cf-justify-content-center cf-align-items-center cf-fill">
  <mat-card appearance="outlined" aria-label="lost password" class="lost-password-card mat-elevation-z8">
    <mat-toolbar color="accent" class="header cf-flex-column cf-justify-content-space-between cf-align-items-center">
      <mat-toolbar-row class="cf-flex-row cf-justify-content-space-between cf-align-items-center">
        <button [routerLink]="['/login']" mat-button class="login-button">
          <mat-icon aria-hidden="false" aria-label="Login arrow backward icon">arrow_backward</mat-icon>
          <span [translate]="'UI.Login'"></span>
        </button>
        <h1 [translate]="'UI.ResetPassword'"></h1>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-card-content class="content">
      <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
        <mat-form-field class="form-field" appearance="outline">
          <mat-label [translate]="'UI.Email'"></mat-label>
          <input type="email" matInput formControlName="email" aria-label="username" required autocomplete="username" />
          @if (email.invalid && (email.dirty || email.touched) && email.errors.email) {
            <mat-error [translate]="'UI.Error.InvalidEmail'"></mat-error>
          }
          @if (email.invalid && (email.dirty || email.touched) && email.errors.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
        </mat-form-field>
        <button
          type="submit"
          mat-raised-button
          class="reset-password-button primary-button"
          aria-label="recover password"
          [disabled]="!form.valid || (isLoading$ | async)"
        >
          {{ 'UI.ResetPassword' | translate }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
